<template>
  <section class="completion-container">
    <div v-if="pageType === 'single'" class="left title">
      <span class="isRequred" v-if="isRequired">*</span>
      <span v-if="isShowNumber == 1">{{ qNo }}</span>
    </div>
    <div class="right">
      <div class="title" v-if="question.subject_title_type == 1">
        <span class="pure-text">{{
          question.title_quote_title_num !== 0 ? optionsTitle : question.subject
        }}</span>
      </div>
      <div v-else>
        <rich-text
          :type="2"
          :content="
            question.title_quote_title_num !== 0
              ? optionsTitle
              : question.subject
          "
        />
      </div>
      <div class="answer-list">
        <section class="inputcomps">
          <input
            :class="[{ focus: isFocus }]"
            placeholder="请输入"
            :maxlength="500"
            v-model="answer"
            autocomplete="on"
            @focus="handleFocus"
            @blur="handleBlur"
            @input="handleInput"
          />
        </section>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 填空题
 */
import RichText from '@/components/rich-text';
export default {
  name: 'Completion',
  components: { RichText },
  props: {
    isShowNumber: {
      //是否显示序号
      type: Number,
      default: 0,
    },
    pageType: {
      type: String,
      default: 'single', // 默认单页展示
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    titleNo: {
      type: Number, // 当前题目序号
      default: 0,
    },
    question: {
      type: Object,
      default: () => {},
    },
    answer_json: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      qNo: this.titleNo < 9 ? `0${this.titleNo}` : this.titleNo, // 问题序号

      answer: '',
      isFocus: false,
    };
  },
  mounted() {},
  methods: {
    handleFocus() {
      this.isFocus = true;
    },
    handleBlur() {
      this.isFocus = false;
    },
    handleInput() {
      this.$emit('change', this.answer, this.index, this.question);
    },
  },
  computed: {
    // 标题引用前题选项
    optionsTitle() {
      const preQuestion =
        this.answer_json[this.question.title_quote_title_num - 1];
      if (this.question.title_quote_title_num !== 0 && preQuestion) {
        let optionsNames = '';
        // 判断题 量表题 打分题取同层的 option_name
        if ([3, 4, 5].includes(preQuestion.subject_type)) {
          optionsNames = preQuestion.option;
          if (preQuestion.subject_type === 3) {
            optionsNames = preQuestion.option_name || '';
          }
        } else {
          optionsNames = preQuestion.option
            .map((item) => item.option_name)
            .join(' ');
        }
        return this.question.subject.replace(/【.*?】/, optionsNames);
        // return '【】'
      } else {
        return this.question.subject.replace(/【.*?】/, '');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.completion-container {
  display: flex;
  .isRequred {
    color: #ff3b30;
    font-size: 18px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 25px;
  }
  .left {
    width: 30px;
    margin-right: 8px;
    text-align: right;
  }
  .right {
    flex: 1;
    .answer-list {
      margin-top: 20px;
      width: 100%;
      .inputcomps {
        input {
          width: 100%;
          padding-left: 10px;
          box-sizing: border-box;
          height: 44px;
          border-radius: 4px;
          border: 1px solid rgba(0, 0, 0, 0.09);
          &.focus {
            border: 1px solid #ff6600;
          }
        }
      }
    }
  }
}
</style>
